import { AudienceTargetingAttributesInput, AudienceUpdate } from '@occc/graphql';

import { prepareAudienceTargetingAttributesInput } from '../../utils';
import { AudienceFormValues } from '../../types';

export const prepareAudienceUpdateInput = (
  audienceId: string,
  values: AudienceFormValues,
): AudienceUpdate => {
  const {
    name,
    description,
    ageWithin,
    behaviors,
    purchases,
    segments,
    fulfillments,
    homeStore,
    walletSteeringItems,
    productInterests,
    qualifiedEvents,
    lastVisit,
    pointBalance,
    membershipCreated,
    employeeTargetingAttributes,
    surveys,
    combinedAudiences,
    externalIdentityVerification,
    communicationPreferences,
  } = values;

  const targetingAttributes: AudienceTargetingAttributesInput =
    prepareAudienceTargetingAttributesInput({
      ageWithin,
      behaviors,
      purchases,
      segments,
      fulfillments,
      homeStore,
      walletSteeringItems,
      productInterests,
      qualifiedEvents,
      lastVisit,
      pointBalance,
      membershipCreated,
      employeeTargetingAttributes,
      surveys,
      combinedAudiences,
      externalIdentityVerification,
      communicationPreferences,
    });

  return {
    uuid: audienceId,
    name,
    description,
    targetingAttributes,
  };
};
